import React from "react";
import { useParams } from "react-router-dom";
import CatalogueWidget from "./CatalogueWidget";

const IframeCatalogue = () => {
  const { widgetId } = useParams();
  return <CatalogueWidget widgetId={widgetId} />;
};

export default IframeCatalogue;
